import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const DBMS = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction: Database System Concepts, Database Users and Administrators, Data Models, Database Schemas and Instances, Database Languages and Interfaces, Data Modeling using the Entity-Relationship Model: Entity Types, Entity Sets, Attributes and Keys, Relationship Types, Relationship Sets, Roles and Structural Constraints, Weak Entity Types, ER Diagrams, Design Issues, and Extended ER Features.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Relational Model and Database Design: Relational Model Concepts, Relational Model Constraints and Relational Database Schemas, Update Operations, Transactions and Dealing with Constraint Violations. Relational Database Design by ER- and EER-to-Relational Mapping. Database Design Theory and Methodology: Informal Design Guidelines for Relation Schemas, Functional Dependencies, Normal Forms Based on Primary Keys, General Definitions of Second and Third Normal Forms, Boyce-Codd Normal Form, Multivalued Dependency and Fourth Normal Form, Join Dependencies and Fifth Normal Form.</p>
    </div>,
    <div key="3" className="p-4">
      <p>SQL and Relational Algebra: SQL: Data Definition and Data Types, Specifying Constraints in SQL, Basic Retrieval Queries in SQL, INSERT, DELETE, and UPDATE Statements in SQL, Additional Features of SQL. Relational Algebra: Unary Relational Operations, Relational Algebra Operations from Set Theory, Binary Relational Operations, Examples of Queries in Relational Algebra.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Transaction Processing and Recovery: Introduction to Transaction Processing, Transaction and System Concepts, Desirable Properties of Transactions, Characterizing Schedules Based on Recoverability, Characterizing Schedules Based on Serializability. Concurrency Control Techniques: Two-Phase Locking Techniques for Concurrency Control, Concurrency Control Based on Timestamp Ordering, Multiversion Concurrency Control Techniques. Database Recovery Techniques: Recovery Concepts, Deferred Update, Immediate Update, Shadow Paging, The ARIES Recovery Algorithm.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Database Management Systems"
      subjectKey="dbms"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'DBMSNotes',
        videos: 'DBMSVideos'
      }}
    />
  );
};

export default DBMS;